<script>
    // ════════════════════════════════════════════════════════════════════════
    // ТАБЛИЧКА ЗАКЛЮЧЁННОГО — правый нижний угол.
    // Показывает, где сидит, сколько осталось, за что и кто посадил.
    // Мест три и они разного смысла, поэтому у каждого свой цвет и значок:
    //   ft  — федеральная тюрьма (красный, решётка)
    //   kpz — камера предварительного заключения (синий, замок)
    //   dem — деморган, наказание администрации (фиолетовый, молния)
    // Секунды отсчитывает сама: гонять их с сервера каждую секунду незачем —
    // сервер присылает состояние при посадке, правке срока, переводе,
    // освобождении и заходе в игру.
    // ════════════════════════════════════════════════════════════════════════
    import { onDestroy } from 'svelte';

    let data = null;      // { kind, seconds, total, reason, by, place }
    let left = 0;
    let total = 0;
    let timer = null;

    const stop = () => { if (timer) { clearInterval(timer); timer = null; } };

    const start = () => {
        stop();
        timer = setInterval(() => {
            if (left > 0) left -= 1;
            else { stop(); data = null; }
        }, 1000);
    };

    // сервер шлёт JSON, пустая строка — снять табличку
    window.arrestInfo = (json) => {
        try {
            if (!json) { stop(); data = null; return; }
            data = typeof json === 'string' ? JSON.parse(json) : json;
            left = data.seconds || 0;
            total = data.total || 0;
            start();
        } catch (e) { data = null; }
    };

    onDestroy(stop);

    // Оформление по месту заключения. Значки — линейные, в одном наборе с худом.
    const BARS = 'M5 3v18M9.7 3v18M14.3 3v18M19 3v18M3 12h18';
    const LOCK = 'M5 13a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2zM12 16v2M8 11v-4a4 4 0 1 1 8 0v4';
    const BOLT = 'M13 3v7h6l-8 11v-7H5z';

    // Полутона (подложка чипа, рамка, свечение) раскладываем готовыми строками,
    // а не считаем их из основного цвета средствами CSS: браузер внутри игры
    // старее того, что это умеет, и панель осталась бы без подложки и рамки.
    const KINDS = {
        ft: {
            color: '#ED6A5E', dark: '#B8362B', rgb: '237,106,94',
            kick: 'Вы задержаны', who: 'Задержал', icon: BARS,
        },
        kpz: {
            color: '#5B8DEF', dark: '#2F5FBF', rgb: '91,141,239',
            kick: 'Вы задержаны', who: 'Задержал', icon: LOCK,
        },
        dem: {
            color: '#A97BEA', dark: '#6E44B0', rgb: '169,123,234',
            kick: 'Наказание администрации', who: 'Выдал', icon: BOLT,
        },
    };
    // старый сервер мог прислать состояние без признака места — тогда считаем
    // это обычной отсидкой, а не показываем пустую карточку
    $: skin = (data && KINDS[data.kind]) || KINDS.ft;

    // час и больше показываем как Ч:ММ:СС — иначе «180:00» читается тяжело
    $: hh = Math.floor(left / 3600);
    $: mm = String(Math.floor((left % 3600) / 60)).padStart(2, '0');
    $: ss = String(left % 60).padStart(2, '0');
    $: clock = hh > 0 ? `${hh}:${mm}:${ss}` : `${mm}:${ss}`;

    // полоса рисуется только если сервер знает полный срок
    $: pct = total > 0 ? Math.max(0, Math.min(100, (left / total) * 100)) : -1;
    $: soon = left > 0 && left <= 60;   // последняя минута — торопим
</script>

{#if data}
    <div class="ai"
         style="--ac: {skin.color}; --ac-dark: {skin.dark};
                --ac-soft: rgba({skin.rgb}, .13); --ac-line: rgba({skin.rgb}, .32);
                --ac-glow: rgba({skin.rgb}, .22); --ac-fade: rgba({skin.rgb}, 0);
                --ac-halo: rgba({skin.rgb}, .45)">
        <div class="ai__glow"></div>

        <div class="ai__head">
            <div class="ai__chip">
                <svg viewBox="0 0 24 24"><path d={skin.icon} /></svg>
            </div>
            <div class="ai__headtxt">
                <div class="ai__kick">{skin.kick}</div>
                <div class="ai__place">{data.place}</div>
            </div>
        </div>

        <div class="ai__time" class:soon>
            <span class="ai__clock">{clock}</span>
            <span class="ai__unit">осталось</span>
        </div>

        {#if pct >= 0}
            <div class="ai__bar"><i style="width:{pct}%"></i></div>
        {/if}

        <div class="ai__rows">
            <div class="ai__row">
                <span class="ai__ic">
                    <svg viewBox="0 0 24 24"><path d="M7 20h10M6 6l6-1 6 1M12 3v17M9 12l-3-6-3 6a3 3 0 0 0 6 0M21 12l-3-6-3 6a3 3 0 0 0 6 0" /></svg>
                </span>
                <span class="ai__col">
                    <span class="ai__key">Причина</span>
                    <span class="ai__val">{data.reason}</span>
                </span>
            </div>

            <div class="ai__row">
                <span class="ai__ic">
                    <svg viewBox="0 0 24 24"><path d="M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1-8.5 15a12 12 0 0 1-8.5-15a12 12 0 0 0 8.5-3M9 12l2 2l4-4" /></svg>
                </span>
                <span class="ai__col">
                    <span class="ai__key">{skin.who}</span>
                    <span class="ai__val">{data.by}</span>
                </span>
            </div>
        </div>
    </div>
{/if}

<style>
    /* Правый нижний угол. Панель машины появляется только за рулём, а за рулём
       из камеры не сидят — пересечься им негде.
       --ac задаётся в разметке: цвет места заключения. */
    .ai {
        position: fixed; right: 2.2vh; bottom: 2.2vh; z-index: 46;
        width: 29vh; padding: 1.7vh 1.8vh 1.6vh;
        border-radius: 1.3vh; overflow: hidden;
        background: rgba(20, 20, 22, .92);
        border: .09vh solid rgba(255, 255, 255, .07);
        box-shadow: 0 1.4vh 3.6vh rgba(0, 0, 0, .55), inset 0 .09vh 0 rgba(255, 255, 255, .05);
        font-family: 'Manrope', 'Gilroy', sans-serif; color: #F2F0EB;
        pointer-events: none;
        animation: aiIn .32s cubic-bezier(.22,.61,.36,1) both;
    }
    @keyframes aiIn { from { opacity: 0; transform: translateX(2.4vh); } to { opacity: 1; transform: none; } }

    /* свечение цвета места из-под верхнего края — даёт панели характер,
       не превращая её в цветной прямоугольник */
    .ai__glow {
        position: absolute; left: 0; right: 0; top: 0; height: 7vh;
        background: radial-gradient(120% 100% at 50% 0%, var(--ac-glow), var(--ac-fade) 70%);
        pointer-events: none;
    }

    /* ── шапка */
    .ai__head { position: relative; display: flex; align-items: center; gap: 1.05vh; }
    .ai__chip {
        flex: 0 0 auto; width: 3.2vh; height: 3.2vh; border-radius: .95vh;
        display: flex; align-items: center; justify-content: center;
        background: var(--ac-soft);
        border: .09vh solid var(--ac-line);
    }
    .ai__chip svg {
        width: 1.75vh; height: 1.75vh; fill: none; stroke: var(--ac);
        stroke-width: 1.9; stroke-linecap: round; stroke-linejoin: round;
    }
    .ai__headtxt { min-width: 0; }
    .ai__kick {
        font-size: 1.02vh; font-weight: 600; letter-spacing: .16vh;
        text-transform: uppercase; color: rgba(242, 240, 235, .42);
        white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
    }
    .ai__place {
        margin-top: .18vh; font-size: 1.5vh; font-weight: 700; line-height: 1.15;
        white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
    }

    /* ── таймер */
    .ai__time { position: relative; display: flex; align-items: baseline; gap: .85vh; margin-top: 1.35vh; }
    .ai__clock {
        font-family: 'Unbounded', 'Manrope', sans-serif;
        font-size: 3.5vh; font-weight: 700; line-height: 1;
        letter-spacing: -.04vh; font-variant-numeric: tabular-nums;
        text-shadow: 0 .2vh 1.2vh rgba(0, 0, 0, .5);
    }
    .ai__unit {
        font-size: 1.02vh; font-weight: 600; letter-spacing: .16vh;
        text-transform: uppercase; color: rgba(242, 240, 235, .42);
    }
    /* последняя минута: цифры красит цветом места и они дышат */
    .ai__time.soon .ai__clock { color: var(--ac); animation: aiPulse 1.1s ease-in-out infinite; }
    @keyframes aiPulse { 0%, 100% { opacity: 1 } 50% { opacity: .5 } }

    .ai__bar {
        position: relative;
        margin-top: 1.15vh; height: .35vh; border-radius: .35vh;
        background: rgba(255, 255, 255, .08); overflow: hidden;
    }
    .ai__bar i {
        display: block; height: 100%; border-radius: .35vh;
        background: linear-gradient(90deg, var(--ac-dark), var(--ac));
        box-shadow: 0 0 1.2vh var(--ac-halo);
        transition: width 1s linear;
    }

    /* ── строки «причина» и «задержал» */
    .ai__rows {
        position: relative;
        margin-top: 1.4vh; padding-top: 1.25vh;
        border-top: .09vh solid rgba(255, 255, 255, .07);
        display: flex; flex-direction: column; gap: 1.05vh;
    }
    .ai__row { display: flex; align-items: flex-start; gap: 1.05vh; }
    .ai__ic {
        flex: 0 0 auto; width: 1.7vh; height: 1.7vh; margin-top: .15vh;
        display: flex; align-items: center; justify-content: center;
    }
    .ai__ic svg {
        width: 100%; height: 100%; fill: none; stroke: rgba(242, 240, 235, .38);
        stroke-width: 1.8; stroke-linecap: round; stroke-linejoin: round;
    }
    .ai__col { display: flex; flex-direction: column; gap: .18vh; min-width: 0; }
    .ai__key {
        font-size: 1.02vh; font-weight: 600; letter-spacing: .14vh;
        text-transform: uppercase; color: rgba(242, 240, 235, .42);
    }
    .ai__val {
        font-size: 1.28vh; font-weight: 600; line-height: 1.32;
        color: #F2F0EB; word-break: break-word;
    }
</style>
